import axios from 'axios';
import { AppSettings,Storage } from '../../configs';
import { authHeader } from '../../helpers/auth-header';

import {
  START_LOADING,
  STOP_LOADING,
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_USER_MANUAL_DATA,
  // UPDATE_USER_MANUAL_DATA,
  UPDATE_USER_MANUAL_MODAL,
  SET_USER_MANUAL_FAIL,
  GET_ALL_USER_MANUAL,
  ERROR_401,
  ERROR_USER_MANUAL_FAIL
  // GET_BUS_PLACE
} from "./actionTypes";

export function startLoginAction() {
  Storage.clear()

  return function (dispatch) {
    dispatch({
      type: START_LOADING
    })

    dispatch({
      type: LOGIN_START
    })
  }
}


export function updateUserManualModalAction(data) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_USER_MANUAL_MODAL,
      data: data
    });
  }
}

export function createUserManualAction(data) {
  return function (dispatch) {
    try {
      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/UserManual/Add`,
        data: data
      })

      promise.then(response => {
        let isSuccess = response.data.isSuccess === true
        let returnMessage = response.data.returnMessage

        if (isSuccess) {
          dispatch({
            type: STOP_LOADING
          })
        } else {
          dispatch({
            type: SET_USER_MANUAL_FAIL,
            payload: returnMessage
          });
          dispatch({
            type: ERROR_USER_MANUAL_FAIL,
            payload: returnMessage
          });
        }

      }
      );

      return promise
    } catch (error) {
    }
  }
}

export function updateUserManualAction(data) {

  return function (dispatch) {

    dispatch({
      type : START_LOADING
    })

    try {

      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/UserManual/Update`,
        data: data
      })

      promise.then(response => {
        dispatch({
          type: STOP_LOADING
        })

        let isSuccess = response.data.isSuccess === true
        if (isSuccess) {
        } else {
          dispatch({
            type: SET_USER_MANUAL_FAIL,
          });
        }
      }
      );

      return promise
    } catch (error) {
      dispatch({
        type: STOP_LOADING
      })
    }
  }
}

export function deleteUserManualAction(id,file_path) {
  return function (dispatch) {

    dispatch({
      type : START_LOADING
    })

    try {
      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/UserManual/Delete`,
        data: {
          "id":id,
          "file_path":file_path
        }
      })

      promise.then(response => {
        dispatch({
          type: STOP_LOADING
        })
        if (response.data.success) {
          dispatch({
            type: SET_USER_MANUAL_DATA,
            payload: response.data.response,
          });
        } else {
          dispatch({
            type: SET_USER_MANUAL_FAIL,
            data: response.data.response,
          });
        }
      }
      );

      return promise
    } catch (error) {
      dispatch({
        type: STOP_LOADING
      })
    }
  }
}

export function getUserManualDataAction() {
  return function (dispatch) {

    dispatch({
      type : START_LOADING
    })

    try {
      let promise = axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "get",
        url: `${AppSettings.apiUrl}/api/UserManual/GetAll`,
      })

      promise.then(response => {
       
        dispatch({
          type: GET_ALL_USER_MANUAL,
          payload: response.data,
        });

        dispatch({
          type: STOP_LOADING
        })
      }
      ).catch(error => {
        dispatch({
          type: STOP_LOADING
        })

        if (error.message && error.message.indexOf("code 401") != -1) {
          window.emitter.emit(ERROR_401)
        }
      })

      return promise
    } catch (error) {
    }
  }
}

export function clearErrorMsgAction() {
  return function (dispatch) {
    dispatch({
      type: SET_USER_MANUAL_FAIL,
      data: ""
    });
  }
}